var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90036 3.85577C10.3863 -0.084084 17.084 -1.02412 22.5998 1.12552C30.5003 3.95945 35.0691 13.3391 32.878 21.3501C31.9172 24.6817 30.051 27.64 28.2608 30.5777C26.6295 27.7714 24.3278 25.442 21.487 23.8592C23.7887 21.4469 25.3439 17.8457 23.761 14.6247C21.8671 9.53745 14.4021 8.04445 10.8701 12.2746C7.55233 15.5371 8.51311 20.8732 11.5751 23.949C8.7412 25.3245 6.57774 27.6677 5.25063 30.5085C2.09875 26.5894 -0.424145 21.7648 0.0596964 16.5808C-0.202961 11.6871 2.30611 7.04221 5.90036 3.85577Z",
    fill: "#515DEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4097 38.2015C12.4396 33.4737 13.0963 28.6767 14.057 23.9351C15.6883 23.942 17.3126 23.942 18.9438 23.942C19.9461 28.6491 20.6649 33.4114 21.6188 38.1324C19.9599 39.6461 18.6397 41.9271 16.5177 42.6943C14.4303 41.8856 13.0963 39.6599 11.4097 38.2015Z",
    fill: "#515DEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.e9e52e167300d96a8f9e6fdf3f30a2d3.svg";
export { ForwardRef as ReactComponent };